import e from "./index282.js";
import { createElementBlock as r, openBlock as t, normalizeClass as n, renderSlot as s } from "vue";
import a from "./index231.js";
const i = ["data-component"];
function d(o, l, c, m, p, u) {
  return t(), r("div", {
    ref: "rootRef",
    "data-component": o.$options.name,
    class: n(["sticky top-0 transition-all duration-200 border border-solid bg-color-neutral-white ease-ms screen-m:border-color-neutral-grey-10", {
      "rounded-10 border-color-neutral-white": !o.isSticky,
      "shadow rounded-t-none rounded-b-10 border-color-neutral-grey-10": o.isSticky,
      "-translate-y-[120%]": !o.isVisible
    }])
  }, [
    s(o.$slots, "default")
  ], 10, i);
}
const k = /* @__PURE__ */ a(e, [["render", d]]);
export {
  k as default
};
